import { Button, Stack, Typography, TextField } from "@mui/material";
import { sendPasswordResetEmail } from "firebase/auth";
import { useState } from "react";
import { auth } from "../../firebase/config";
import BackdropLoader from "../../components/Common/BackdropLoader";

export default function ResetPassword({ setResetMode }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleBack = () => setResetMode(false);
  const handleReset = async () => {
    setMessage("");
    setError("");
    try {
      if (email) {
        setLoading(true);
        await sendPasswordResetEmail(auth, email);
        setEmail("");
        setMessage("Reset password mail has been sent to your email.");
        setLoading(false);
      }
    } catch (error) {
      console.log("Reset Password Error : ", error);
      setError(error);
      setLoading(false);
    }
  };
  return (
    <Stack gap={2}>
      <BackdropLoader open={loading} />
      <Typography variant="h6">Reset Password</Typography>
      <TextField
        id="email"
        label="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        autoComplete="current-email"
        InputLabelProps={{
          shrink: true,
        }}
      />
      <Stack
        direction={"row"}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Button variant="outlined" onClick={handleBack}>
          Back
        </Button>
        <Button variant="contained" onClick={handleReset}>
          Reset
        </Button>
      </Stack>
      {message && <Typography color="success">{message}</Typography>}
      {error && <Typography color="error">{error}</Typography>}
    </Stack>
  );
}
